import axios from 'axios';
import React, { useEffect, useState } from 'react';

function RemoteAPI() {
    
    let [likes, changeLikes] = useState(0) //likes state
    let [dislikes, changeDislikes] = useState(0) //dislikes state
    let[remoteUsers, updateRemoteUseres] = useState([])


    //useEffect will take 2 parameters
    //1. callback function :  use axios to call api in callback function
    //2. array
    useEffect(() =>{
        //use axios.get() to send GET request to api
        axios.get("https://jsonplaceholder.typicode.com/albums")

        //then will come in action if response is received
        //deal with incoming response in callback function
        .then((response) => {
            console.log(response)
            console.log(response.data)
            updateRemoteUseres(response.data)
        })

        //catch will come in action if error is received
        //deal with incoming error in callback function
        .catch((error) => {
            console.log=(error)
        })
    },[])

    const increaseLikes = ()=>{
        changeLikes(likes + 1)
    }

    const increaseDislikes = ()=>{
        changeDislikes(dislikes + 1)
    }

    const displayRemoteUsers = () =>{
        return remoteUsers.map((user) =>{
            return(
                <li>
                    {user.title}
                </li>
            )
        })
    }
    
    return ( 
        <div>
            <h1>
                Display data after receiving response from remote API!
            </h1>
            <h2>
                Likes: {likes}
            </h2>
            <h2>
                Dislikes: {dislikes}
            </h2>
            <button onClick={increaseLikes}>
                Add Likes
            </button>
            <br></br>
            <br></br>
            <button onClick={increaseDislikes}>
                Add Dislikes
            </button>
            <div>
                <h2>Remote Data: {remoteUsers.length >=10 ? remoteUsers.length : "Loading users..."}</h2>
            </div>
            <div>
                <ol>
                    {displayRemoteUsers()}
                </ol>
            </div>
           
        </div>
     );
}

export default RemoteAPI;